import React, { forwardRef } from "react";
import { Switch } from "@progress/kendo-react-inputs";

/**
 * DKNSwitch — Daikin design system toggle switch.
 * Wraps Kendo Switch.
 *
 * Props:
 *   checked    boolean — controlled state
 *   onChange   (e) => void  — e.value is boolean
 *   label      string — label beside the switch
 *   labelPlacement "start" | "end"  (default: "end")
 *   disabled   boolean
 */
const DKNSwitch = forwardRef(function DKNSwitch(
  {
    checked,
    onChange,
    label,
    labelPlacement = "end",
    disabled = false,
    className = "",
    style,
    ...rest
  },
  ref
) {
  return (
    <label
      className={`dkn-switch-wrap ${className}`}
      style={{ display: "inline-flex", alignItems: "center", gap: "0.5rem", cursor: disabled ? "not-allowed" : "pointer", ...style }}
    >
      {label && labelPlacement === "start" && (
        <span className="dkn-switch-label">{label}</span>
      )}
      <Switch
        ref={ref}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        {...rest}
      />
      {label && labelPlacement === "end" && (
        <span className="dkn-switch-label" style={{ color: disabled ? "var(--text-secondary)" : "var(--text-primary)", fontSize: "0.875rem" }}>
          {label}
        </span>
      )}
    </label>
  );
});

export default DKNSwitch;
